import {ProcedureType} from 'graphql-client/__generated/graphqlGlobalTypes';
import {
  extractMaterialEdges,
  getOrderedDownstreamLinearMethodNodes,
} from 'procedures/design/flowchartManagementUtils';
import {ProcedureFlowchart} from 'procedures/ProcedureDomainTypes';
import getProcedureUIString, {ProceduresStringKeys, StringCase} from 'procedures/ProceduresStringKeys';

import {
  ProcedureValidationError,
  ProcedureValidationErrorType,
  ProcedureValidationObjectType,
} from '../ProcedureValidationTypes';

export function validateProcedureMaterialEdges(
  flowchart: ProcedureFlowchart,
  procedureType: ProcedureType
): Array<ProcedureValidationError> {
  const methodUIString = getProcedureUIString(ProceduresStringKeys.METHOD, procedureType, {
    plural: true,
    stringCase: StringCase.LOWER,
  });

  return extractMaterialEdges(flowchart.edges).flatMap((edge) =>
    getOrderedDownstreamLinearMethodNodes(flowchart, edge.fromMethodCid).find(
      (node) => node.cid === edge.toMethodCid
    ) == null
      ? {
          errorMessage: `Materials can only flow from left to right between ${methodUIString}`,
          type: ProcedureValidationErrorType.UPSTREAM_MATERIAL_EDGE,
          primaryObject: {id: edge.id, objectType: ProcedureValidationObjectType.MATERIAL_EDGE},
          parentObjects: [
            {id: edge.fromMethodCid, objectType: ProcedureValidationObjectType.METHOD},
            {id: edge.toMethodCid, objectType: ProcedureValidationObjectType.METHOD},
          ],
        }
      : []
  );
}
